import { render, staticRenderFns } from "./AlarmActiveList.vue?vue&type=template&id=a64939b4"
import script from "./AlarmActiveList.vue?vue&type=script&lang=js"
export * from "./AlarmActiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports